(function () {
  Chart.rings = function (params) {
    let data = _.filter(params.data, { clasificacion: "TOS FERINA" });
    let temp = _.filter(params.data, function (d) {
      return d.tipo == "agregadodef";
    });
    //console.log("temp");
    // console.log(temp);
    /*
    data = _.filter(params.data, function (d) {
      return d.tipo != "agregadodef";
    });
*/
    const formato = params.formato;
    const el = params.el;
    const partido = params.partido;

    let circles1;
    let circles2;
    let circles3;
    let circles4;

    let lines;
    let circles;

    const nucleos = {
      general: { x: 0, y: -1400 },
      vacunacion: {
        1: { x: 1200, y: -800 },
        2: { x: -1200, y: -700 },
      },
      evolucion: {
        3: { x: -700, y: 100 },
        4: { x: 700, y: 100 },
        5: { x: 700, y: 100 },
      },
    };

    let box = new Box({
      size: { width: 3200, height: 2400 },
      padding: 20,
    });

    let svg = null;
    let gNodos = null;
    let gLineas = null;
    let gRotulos = null;
    let gLeyenda = null;

    /*
    const color = d3
      .scaleOrdinal()
      .domain([+1, +2])
      .range(["#5bcfb8", "#a54cfc"])
      .unknown("#ffff00");
      */

    const color = d3.scaleOrdinal(d3.schemeCategory10);

    const formatTime = d3.utcFormat("%d de %B de %Y");

    function setup() {
      //data = _.filter(data, { clasificacion: "TOS FERINA" });
      crearSVG(el);
      crearAnillos();
      crearLeyenda();
    }

    function crearLeyenda() {
      let arreglo = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];
      let l = 40;
      let espacio = 20;
      let valY = 0;

      gLeyenda.append("text").text("Años").attr("x", 0).attr("y", valY);

      valY += espacio;

      _.each(arreglo, function (d) {
        let colorRelleno = color(d);
        let texto = d;

        gLeyenda
          .append("rect")
          .style("fill", colorRelleno)
          .attr("x", 0)
          .attr("y", valY)
          .attr("width", l)
          .attr("height", l);

        gLeyenda
          .append("text")
          .text(texto)
          .attr("x", l + espacio / 2)
          .attr("y", valY + l / 2 + 3)
          .attr("dominant-baseline", "middle");

        valY += espacio + l;
      });
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height + 200}`);

      svg.on("click", reset);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr("transform", `translate(${box.padding.left}, ${box.padding.top})`)
        .style("font-size", "48px");

      gLineas = svg
        .append("g")
        .attr("data-g", "gLineas")
        .style("stroke", "#efefef")
        .style("stroke-width", "1px")
        .attr("transform", `translate(${box.content.width / 2}, 2000)`);

      gNodos = svg
        .append("g")
        .attr("data-g", "gNodos")
        .attr("transform", `translate(${box.content.width / 2}, 2000)`);

      gRotulos = svg
        .append("g")
        .attr("data-g", "gRotulos")
        .attr("transform", `translate(${box.content.width / 2}, 2000)`);

      gLeyenda = svg
        .append("g")
        .attr("data-g", "gLeyenda")
        .attr("transform", `translate(100, 100)`);
    }

    function ticked() {
      lines
        .attr("x1", function (d) {
          return d.source.x;
        })
        .attr("y1", function (d) {
          return d.source.y;
        })
        .attr("x2", function (d) {
          return d.target.x;
        })
        .attr("y2", function (d) {
          return d.target.y;
        });

      circles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
    }

    function ticked1() {
      circles1.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
    }

    function ticked2() {
      circles2.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
    }

    function getClonedData(v) {
      let arreglo = _.cloneDeep(data);
      _.each(arreglo, function (d) {
        d.id = `${v}-${d.anio}-${d.fila_archivo}`;
        d.anillo = `anillo-${v}`;
      });
      return arreglo;
    }

    const dataGeneral = getClonedData(1);
    const dataVacunacion = _.filter(getClonedData(2), function (d) {
      return [1, 2].includes(d.vacunado);
    });
    const dataEvolucion = _.filter(getClonedData(3), function (d) {
      return [3, 4, 5].includes(d.evolucion);
    });

    function crearAnillos() {
      _.each(dataGeneral, function (d) {
        d.center = nucleos.general;
      });

      _.each(dataVacunacion, function (d) {
        switch (d.vacunado) {
          case 1:
          case 2:
            d.center = nucleos.vacunacion[d.vacunado];
            break;
          default:
            break;
        }
      });

      _.each(dataEvolucion, function (d) {
        switch (d.evolucion) {
          case 3:
          case 4:
          case 5:
            d.center = nucleos.evolucion[d.evolucion];
            break;
          default:
            break;
        }
      });

      let objetoArreglos = {};

      let root = empacaDatos(dataGeneral);
      objetoArreglos.general = root.children;

      gNodos
        .selectAll("circle.node.general")
        .data(root.children)
        .enter()
        .append("circle")
        .attr("class", "node general")
        .attr("cx", (d) => d.data.center.x + d.x)
        .attr("cy", (d) => d.data.center.y + d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.data.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);

      root = empacaDatos(_.filter(dataVacunacion, { vacunado: 2 }));
      objetoArreglos.vacunacion = [];
      objetoArreglos.vacunacion.push(root.children);

      gNodos
        .selectAll("circle.node.sinvacuna")
        .data(root.children)
        .enter()
        .append("circle")
        .attr("class", "node sinvacuna")
        .attr("cx", (d) => d.data.center.x + d.x)
        .attr("cy", (d) => d.data.center.y + d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.data.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);
      //console.log(root.children);
      root = empacaDatos(_.filter(dataVacunacion, { vacunado: 1 }));
      objetoArreglos.vacunacion.push(root.children);

      gNodos
        .selectAll("circle.node.convacuna")
        .data(root.children)
        .enter()
        .append("circle")
        .attr("class", "node convacuna")
        .attr("cx", (d) => d.data.center.x + d.x)
        .attr("cy", (d) => d.data.center.y + d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.data.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);

      root = empacaDatos(_.filter(dataEvolucion, { evolucion: 3 }));
      objetoArreglos.evolucion = [];
      objetoArreglos.evolucion.push(root.children);

      gNodos
        .selectAll("circle.node.defuncion")
        .data(root.children)
        .enter()
        .append("circle")
        .attr("class", "node defuncion")
        .attr("cx", (d) => d.data.center.x + d.x)
        .attr("cy", (d) => d.data.center.y + d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.data.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);

      root = empacaDatos(_.filter(dataEvolucion, (d) => d.evolucion != 3));
      objetoArreglos.evolucion.push(root.children);

      gNodos
        .selectAll("circle.node.hospitalizacion")
        .data(root.children)
        .enter()
        .append("circle")
        .attr("class", "node hospitalizacion")
        .attr("cx", (d) => d.data.center.x + d.x)
        .attr("cy", (d) => d.data.center.y + d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.data.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);

      objetoArreglos.vacunacion = _.flatten(objetoArreglos.vacunacion);
      objetoArreglos.evolucion = _.flatten(objetoArreglos.evolucion);

      const links = [];

      _.each(objetoArreglos.general, function (d) {
        let targetId = `2-${d.data.anio}-${d.data.fila_archivo}`;
        let o =
          _.find(objetoArreglos.vacunacion, function (t) {
            return t.data.id == targetId;
          }) || false;
        if (o) {
          links.push({
            source: d,
            target: o,
          });
        }
      });

      _.each(objetoArreglos.general, function (d) {
        let targetId = `3-${d.data.anio}-${d.data.fila_archivo}`;
        let o =
          _.find(objetoArreglos.evolucion, function (t) {
            return (
              t.data.id == targetId &&
              t.data.evolucion == 3 &&
              t.data.vacunado == 9
            );
          }) || false;
        if (o) {
          links.push({
            source: d,
            target: o,
          });
        }
      });

      _.each(objetoArreglos.general, function (d) {
        let targetId = `3-${d.data.anio}-${d.data.fila_archivo}`;
        let o =
          _.find(objetoArreglos.evolucion, function (t) {
            return (
              t.data.id == targetId &&
              t.data.evolucion != 3 &&
              t.data.vacunado == 9
            );
          }) || false;
        if (o) {
          links.push({
            source: d,
            target: o,
          });
        }
      });

      _.each(objetoArreglos.vacunacion, function (d) {
        let targetId = `3-${d.data.anio}-${d.data.fila_archivo}`;
        let o =
          _.find(objetoArreglos.evolucion, function (t) {
            return t.data.id == targetId;
          }) || false;
        if (o) {
          links.push({
            source: d,
            target: o,
          });
        }
      });

      gLineas
        .selectAll("line.link")
        .data(links)
        .enter()
        .append("line")
        .classed("link", true)
        .attr("x1", function (d) {
          return d.source.data.center.x + d.source.x;
        })
        .attr("y1", function (d) {
          return d.source.data.center.y + d.source.y;
        })
        .attr("x2", function (d) {
          return d.target.data.center.x + d.target.x;
        })
        .attr("y2", function (d) {
          return d.target.data.center.y + d.target.y;
        });

      gRotulos
        .append("text")
        .text("Contagios")
        .style("text-anchor", "middle")
        .attr("x", nucleos.general.x)
        .attr("y", nucleos.general.y - 520);

      gRotulos
        .append("text")
        .text("Personas vacunadas")
        .style("text-anchor", "middle")
        .attr("x", nucleos.vacunacion[1].x)
        .attr("y", nucleos.vacunacion[1].y + 250);

      gRotulos
        .append("text")
        .text("Personas sin vacunar")
        .style("text-anchor", "middle")
        .attr("x", nucleos.vacunacion[2].x)
        .attr("y", nucleos.vacunacion[2].y + 380);

      gRotulos
        .append("text")
        .text("Defunciones")
        .style("text-anchor", "middle")
        .attr("x", nucleos.evolucion[3].x)
        .attr("y", nucleos.evolucion[3].y + 130);

      gRotulos
        .append("text")
        .text("Personas hospitalizadas")
        .style("text-anchor", "middle")
        .attr("x", nucleos.evolucion[4].x)
        .attr("y", nucleos.evolucion[4].y + 350);
    }

    function empacaDatos(datos) {
      let obj = { children: datos };

      let h = d3
        .hierarchy(obj)
        .sum((d) => (d.value ? 1 : 0))
        .sort((a, b) => b.value - a.value);

      let fPack = d3
        .pack()
        .size([0, 0])
        .padding(2)
        .radius((d) => 6);
      let pack = () => fPack(h);

      let root = pack(datos);
      root.offset = { x: root.r, y: root.r };
      _.each(root.children, function (o) {
        o.offset = root.offset;
      });

      return root;
    }

    function crearAnillos0() {
      _.each(dataGeneral, function (d) {
        d.center = nucleos.general;
      });

      gRotulos
        .append("text")
        .text("Contagios")
        .style("text-anchor", "middle")
        .attr("x", nucleos.general.x)
        .attr("y", nucleos.general.y - 400);

      _.each(dataVacunacion, function (d) {
        switch (d.vacunado) {
          case 1:
          case 2:
            d.center = nucleos.vacunacion[d.vacunado];
            break;
          default:
            break;
        }
      });

      gRotulos
        .append("text")
        .text("Personas vacunadas")
        .style("text-anchor", "middle")
        .attr("x", nucleos.vacunacion[1].x)
        .attr("y", nucleos.vacunacion[1].y + 300);

      gRotulos
        .append("text")
        .text("Personas sin vacunar")
        .style("text-anchor", "middle")
        .attr("x", nucleos.vacunacion[2].x)
        .attr("y", nucleos.vacunacion[2].y + 400);

      _.each(dataEvolucion, function (d) {
        switch (d.evolucion) {
          case 3:
          case 4:
          case 5:
            d.center = nucleos.evolucion[d.evolucion];
            break;
          default:
            break;
        }
      });

      gRotulos
        .append("text")
        .text("Defunciones")
        .style("text-anchor", "middle")
        .attr("x", nucleos.evolucion[3].x)
        .attr("y", nucleos.evolucion[3].y + 150);

      gRotulos
        .append("text")
        .text("Personas hospitalizadas")
        .style("text-anchor", "middle")
        .attr("x", nucleos.evolucion[4].x)
        .attr("y", nucleos.evolucion[4].y + 370);

      const links = [];
      const arreglo = _.flatten([dataGeneral, dataVacunacion, dataEvolucion]);

      _.each(dataGeneral, function (d) {
        let targetId = `2-${d.anio}-${d.fila_archivo}`;
        let o = _.find(dataVacunacion, { id: targetId }) || false;
        if (o) {
          let sourceId = `1-${d.anio}-${d.fila_archivo}`;
          links.push({
            source: sourceId,
            target: targetId,
          });
        }
      });

      //console.log(_.filter(dataEvolucion, { evolucion: 3 }));

      _.each(dataGeneral, function (d) {
        let targetId = `3-${d.anio}-${d.fila_archivo}`;
        let o =
          _.find(dataEvolucion, { id: targetId, evolucion: 3, vacunado: 9 }) ||
          false;
        if (o) {
          let sourceId = `1-${d.anio}-${d.fila_archivo}`;
          if (o.evolucion != 3) {
            //console.log(o);
          }
          links.push({
            source: sourceId,
            target: targetId,
          });
        }
      });

      _.each(dataVacunacion, function (d) {
        let targetId = `3-${d.anio}-${d.fila_archivo}`;
        let o = _.find(dataEvolucion, { id: targetId }) || false;
        if (o) {
          let sourceId = `2-${d.anio}-${d.fila_archivo}`;
          links.push({
            source: sourceId,
            target: targetId,
          });
        }
      });

      /*

      console.log("arreglo");
      console.log(arreglo);
      let links = [];
      _.each(data, function (d) {
        links.push({
          source: `1-${d.fila_archivo}`,
          target: `2-${d.fila_archivo}`,
        });
        links.push({
          source: `2-${d.fila_archivo}`,
          target: `3-${d.fila_archivo}`,
        });
      });
*/
      //console.log("links");
      //console.log(links);

      let sim = d3
        .forceSimulation(arreglo)

        .force(
          "link",
          d3
            .forceLink()
            .id((d) => d.id)
            .links(links)
            .strength(0),
        )

        .force(
          "x",
          d3
            .forceX()
            .x((d) => d.center.x)
            .strength(0.2),
        )
        .force(
          "y",
          d3
            .forceY()
            .y((d) => d.center.y)
            .strength(0.2),
        )
        .force("collide", d3.forceCollide().radius(8))
        //.stop();
        //.tick(300);
        .on("tick", ticked);

      circles = gNodos
        .selectAll("circle.node")
        .data(arreglo)
        .enter()
        .append("circle")
        .classed("node", true)
        .attr("cx", (d) => d.x)
        .attr("cy", (d) => d.y)
        .attr("r", (d) => 6)
        .style("fill", (d) => color(d.anio))
        .on("mouseover", crearTooltip)
        .on("click", toggleRaiz);

      lines = gLineas
        .selectAll("line.link")
        .data(links)
        .enter()
        .append("line")
        .classed("link", true)
        .attr("x1", function (d) {
          return d.source.x;
        })
        .attr("y1", function (d) {
          return d.source.y;
        })
        .attr("x2", function (d) {
          return d.target.x;
        })
        .attr("y2", function (d) {
          return d.target.y;
        });
    }

    function crearTooltip(ev, d) {
      ev.preventDefault();
      let el = d3.select(this).node();
      tippy(el, {
        theme: `anio-${d.data.anio}`,
        content: `<h4>${d.data.anio}</h4><strong>Edad: </strong>${d.data.grupo_edad} años<br><strong>Sexo: </strong>${d.data.sexo == 1 ? "Masculino" : "Femenino"}<br><strong>Fecha</strong>: ${formatTime(new Date(d.data.fecha_notificacion))}<br><strong>Estado: </strong>${d.data.entidad_residencia}`,
        allowHTML: true,
      });
    }

    let flagReset = false;

    function reset(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      if (flagReset) {
        gNodos
          .selectAll("circle.node")
          .style("fill", (d) => color(d.data.anio));
        gLineas
          .selectAll("line.link")
          .style("stroke", null)
          .style("opacity", null);
        flagReset = false;
      }
    }

    function toggleRaiz(ev, d) {
      ev.preventDefault();
      ev.stopPropagation();

      flagReset = true;

      let nodos = gNodos.selectAll("circle.node");
      let nodosResaltados = nodos.filter(
        (n) =>
          n.data.anio == d.data.anio &&
          n.data.fila_archivo == d.data.fila_archivo,
      );
      let nodosOpacados = nodos.filter(
        (n) =>
          !(
            n.data.anio == d.data.anio &&
            n.data.fila_archivo == d.data.fila_archivo
          ),
      );

      nodosResaltados
        .transition()
        .duration(400)
        .style("fill", (d) => color(d.data.anio));
      nodosOpacados.transition().duration(400).style("fill", "#cdcdcd");

      let lineas = gLineas.selectAll("line.link");
      let lineasResaltadas = lineas.filter(function (l) {
        return (
          (l.source.data.anio == d.data.anio &&
            l.source.data.fila_archivo == d.data.fila_archivo) ||
          (l.target.data.anio == d.data.anio &&
            l.target.data.fila_archivo == d.data.fila_archivo)
        );
      });
      let lineasOpacadas = lineas.filter(function (l) {
        return !(
          (l.source.data.anio == d.data.anio &&
            l.source.data.fila_archivo == d.data.fila_archivo) ||
          (l.target.data.anio == d.data.anio &&
            l.target.data.fila_archivo == d.data.fila_archivo)
        );
      });

      lineasResaltadas
        .transition()
        .duration(400)
        .style("stroke", "#000000")
        .style("opacity", null);
      lineasOpacadas
        .transition()
        .duration(400)
        .style("stroke", null)
        .style("opacity", 0.1);
    }

    return setup();
  };
})();
